import { connect } from 'react-redux';
import SMART from './SMART';

import { setSMARTValue } from '../../common/smart/actions';


import { setSMARTisVisible } from './actions';

const mapStateToProps = state => ({
    isLocked: state.isLockedUI.isLocked,
    isVisible: state.smartUI.isVisible,
    smartValue: state.smart.smartValue,
    setSMARTisVisible,
    setSMARTValue,
});

const combinedActions = {
    setSMARTisVisible,
    setSMARTValue,
};

export default connect(mapStateToProps, combinedActions)(SMART);



// WEBPACK FOOTER //
// ./src/containers/Inputs/SMART/index.js